import { useLocation } from 'react-router-dom'

export const useHistoryState = () => {
  const { state } = useLocation()
  return state || {}
}
